 
import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getAssets } from 'src/api/stoApi';
import { Asset, SPV } from 'src/models';
import { TAssetStage } from '@brickwise/asset-validation/dist/schema/enums';
import { generalStore } from 'src/stores/GeneralStore';

export const useAssetsFiltered = (filter: TAssetStage[], spvId?: SPV['id']) => {
  const [filteredAssets, setFilteredAssets] = useState<Asset[] | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        const response = await getAssets();
        const filterByAssetStage = response.data.filter((asset) => filter.includes(asset.investmentDetails.stage!));
        if (!spvId) setFilteredAssets(filterByAssetStage);
        if (spvId) {
          const filterBySpv = filterByAssetStage.filter((asset) => asset.investmentDetails?.spv?.id === spvId);
          if (filterBySpv.length === 0) apiErrorHandling(new Error('No assets found for this SPV.'), 'No assets found for this SPV.');
          setFilteredAssets(filterBySpv);
        }
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, []);

  return filteredAssets;
};
